import type { GetPreview } from "../types";

export const getPreview: GetPreview<"PageContentWidgetAnchor"> = (widget) => {
  return widget;
};
